import * as actions from "../actions/interface";
import update from "immutability-helper";
/**
 * reducer for changes to interface settings
 */
const settingsReducer = {
    reducers: {
        [actions.setLanguage]: (state, payload) => update(state, { language: { $set: payload } }),
        [actions.setAdvancedMode]: (state, payload) => update(state, { advanced: { $set: payload.advanced } }),
        [actions.setProfilesVisible]: (state, payload) => update(state, { profilesVisible: { $set: payload.visible } }),
        [actions.setDesktopNotifications]: (state, payload) => update(state, { desktopNotifications: { $set: payload } }),
        [actions.setHideTopLevelCategory]: (state, payload) => update(state, { hideTopLevelCategory: { $set: payload.hide } }),
        [actions.showUsageInstruction]: (state, payload) => update(state, { usage: { [payload.usageId]: { $set: payload.show } } }),
        [actions.setRelativeTimes]: (state, payload) => update(state, { relativeTimes: { $set: payload } }),
        [actions.setForegroundDL]: (state, payload) => update(state, { foregroundDL: { $set: payload } }),
    },
    defaults: {
        language: "en",
        advanced: false,
        profilesVisible: true,
        desktopNotifications: false,
        hideTopLevelCategory: false,
        relativeTimes: true,
        foregroundDL: true,
        usage: {},
    },
};
export default settingsReducer;
